import { Serializable } from '@/models/core/serializable';

export class JgrowEventLikertScaleAnswer implements Serializable<JgrowEventLikertScaleAnswer> {
  likertScaleID: number; // リッカート尺度設問ID
  value: number; // 回答

  deserialize(input: any): JgrowEventLikertScaleAnswer {
    this.likertScaleID = input.likertScaleID;
    this.value = input.value;

    return this;
  }
}
